import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { KlmrTimesheetPendingPage } from './klmr-timesheet-pending';

@NgModule({
  declarations: [
    KlmrTimesheetPendingPage,
  ],
  imports: [
    IonicPageModule.forChild(KlmrTimesheetPendingPage),
  ],
})
export class KlmrTimesheetPendingPageModule {}



// WEBPACK FOOTER //
// ./src/pages/klmr-timesheet-pending/klmr-timesheet-pending.module.ts